import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { getUserConfiguration } from 'owa-session-store';
export function logCurrentTimeZoneQuick() {
    var UserOptions = getUserConfiguration().UserOptions;
    if (UserOptions.TimeZone != null) {
        var customData = datapoints.CurrentTimeZoneQuick.datapoint.customData(UserOptions.TimeZone);
        logUsage(datapoints.CurrentTimeZoneQuick.datapoint.name, customData);
    }
}
export function logDateFormatQuick() {
    var UserOptions = getUserConfiguration().UserOptions;
    if (UserOptions.DateFormat != null) {
        var customData = datapoints.DateFormatQuick.datapoint.customData(UserOptions.DateFormat);
        logUsage(datapoints.DateFormatQuick.datapoint.name, customData);
    }
}
export function logTimeFormatQuick() {
    var UserOptions = getUserConfiguration().UserOptions;
    if (UserOptions.TimeFormat != null) {
        var customData = datapoints.TimeFormatQuick.datapoint.customData(UserOptions.TimeFormat);
        logUsage(datapoints.TimeFormatQuick.datapoint.name, customData);
    }
}
//# sourceMappingURL=logDataOnSaveRegionalOptions.js.map